<tg-row class="summary-page-motors-contact-details-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Contact details</p>
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-motors-contact-details-section__header--right">
        <a routerLink="../{{ stepIds.listingDetails }}"
            routerLinkActive="active"
            class="h-link-no-visited">
            {{summarySectionLinkText}} contact details
        </a>
    </tg-col>
</tg-row>
<tg-row *ngIf="displayMobileNumber">
    <tg-col class="summary-page-motors-contact-details-section__content">
        <span class="summary-page-motors-contact-details-section__content-label">Display mobile number:</span>
        {{ mobileNumber | tmPhoneNumberFormat }}
    </tg-col>
</tg-row>
<tg-row *ngIf="displayLandlineNumber">
    <tg-col class="summary-page-motors-contact-details-section__content">
        <span class="summary-page-motors-contact-details-section__content-label">Display landline number:</span>
        {{ landlineNumber | tmPhoneNumberFormat }}
    </tg-col>
</tg-row>
